import * as z from "zod";

export const setDefaultShipFromLocation = {
  name: "setDefaultShipFromLocation" as const,
  input: z.object({ locationId: z.string() }),
  output: z.object({}),
};
